
export enum RouteActionCd {
	RELEASE = 'Release',
	RENAME = 'Rename'}

